<template>
    <div class="max-w-6xl w-auto mx-auto grid grid-cols-12 gap-6 mt-8 pb-8">
        <div class="col-span-12">
            <div v-if="$d().admin">
                <p class="mb-8 text-lg">SUBIR DOCUMENTOS</p>
                <vue-dropzone class="bg-white border-none p-8 rounded-lg shadow-lg flex items-center justify-center" ref="myVueDropzone" id="dropzone" v-on:vdropzone-success="save" :options="dropzoneOptions"></vue-dropzone>
            </div>
            <p class="my-8 text-lg" v-if="$d().admin">LISTADO DE DOCUMENTOS</p>
            <!-- BEGIN: File Manager Filter -->
            <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
                <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
                    <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300" />
                    <input type="text" v-model="searchTerm" class="input w-full sm:w-64 box px-10 text-gray-700 dark:text-gray-300 placeholder-theme-13" placeholder="Buscar..." />
                </div>
            </div>
            <!-- END: File Manager Filter -->
            <!-- BEGIN: Directory & Files -->
            <file-list :searchTerm="searchTerm"></file-list>
            <!-- END: Directory & Files -->
        </div>
        <modal :data="{ 'id':'ok-confirmation-modal', 'title':'Guardado', 'text':'Los archivos han sido subidos', 'icon':'check'}"></modal>
        <modal :data="{ 'id':'error-confirmation-modal', 'title':'Error', 'text':'Ha ocurrido un error en la subida', 'icon':'x'}"></modal>
    </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Modal from "@/global-components/Modal";
import FileList from "@/components/FileList";

export default {
    components: {
        Modal,
        File,
        FileList,
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            searchTerm: "",
            dropzoneOptions: {
                url: '/file-upload/',
                thumbnailWidth: 150,
                maxFilesize: 3,
                acceptedFiles: 'application/pdf',
                headers: { "My-Awesome-Header": "header value" },
                dictDefaultMessage: `
                    <div class="flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 w-20 h-20 text-gray-300 feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
                        <p class="text-gray-600">Arrastra o haz clic para subir el documento seleccionado</p>
                    </div>
                `,
                dictFallbackMessage: "Tu navegador no soporta la subida de archivos mediante arrastrar y soltar.",
                dictFallbackText: "Por favor, usa el siguiente formulario para subir tus archivos como en los viejos tiempos.",
                dictFileTooBig: "El archivo es demasiado grande ({{filesize}}MiB). Tamaño máximo de archivo: {{maxFilesize}}MiB.",
                dictInvalidFileType: "No puedes subir archivos de este tipo.",
                dictResponseError: "El servidor respondió con el código {{statusCode}}.",
                dictCancelUpload: "Cancelar la carga",
                dictCancelUploadConfirmation: "¿Estás seguro de que quieres cancelar esta subida?",
                dictRemoveFile: "Eliminar el archivo",
                dictMaxFilesExceeded: "No puedes subir más archivos.",
            },
        }
    },
    methods: {
        async save(file, response) {
            this.$refs.myVueDropzone.removeFile(file);
            try {
                response = JSON.parse(response);
                if (response.data && response.data[0]) {
                    let nombre_del_archivo = prompt('¿Nombre del archivo?', 'Nuevo archivo');
                    if(!nombre_del_archivo) nombre_del_archivo = 'Nuevo archivo';
                    let data = {
                        title: nombre_del_archivo,
                        archivo_ruta: response.data[0].urlPath
                    }
                    let response_save = await CmsApi.hook('/hooks/save/', {'action': 'guardar_archivo', 'data': JSON.stringify(data)});
                    if(response_save.success) {
                        window.bus.$emit("reloadDataFromServer", {});
                    } else {
                        alert('Ha habido un error con la subida del archivo, si este error persiste contacte con el administrador y facilítele el archivo que trata de subir');
                    }
                    cash("#ok-confirmation-modal").modal("show");
                }
            } catch (error) {
                console.error({ 'response': response, 'error': error });
            }
        }
    }
};
</script>